const getters = {
    adminUserInfo: state => state.user.adminUserInfo,
    roles: state => state.user.roles,
    grades: state => state.user.grades,
    branchSchools: state => state.user.branchSchools,
}
export default getters